var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    ref: "editmodal",
    staticClass: "modify-modal modify-modal__edit",
    attrs: {
      value: _vm.isOpen,
      variant: "default",
      "no-footer": "",
      "aria-labelled-by":
        _vm.isStepTwo || !_vm.isMultiRoomReservation
          ? "modify-edit-modal-title-step-two"
          : "modify-edit-modal-title-step-one",
    },
    on: { input: _vm.handleOpenModal, close: _vm.handleCloseModal },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function (ref) {
            var activate = ref.activate
            return [_vm._t("default", null, null, { activate: activate })]
          },
        },
        {
          key: "header",
          fn: function () {
            return [
              _c("div", { staticClass: "modify-modal__edit-header" }, [
                _vm.isMultiRoomReservation
                  ? _c("div", [
                      _c("div", { staticClass: "step" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.ModifyReservationPopupStepsLabel) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.isStepTwo
                        ? _c(
                            "div",
                            {
                              staticClass: "title",
                              attrs: { id: "modify-edit-modal-title-step-one" },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.ModifyReservationPopupTitle) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isStepTwo || !_vm.isMultiRoomReservation
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "title",
                          attrs: { id: "modify-edit-modal-title-step-two" },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.ModifyReservationPopupStepTwoTitle) +
                              "\n        "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [
              _vm.isMultiRoomReservation && !_vm.isStepTwo
                ? _c("div", [
                    _c("div", { staticClass: "modify-modal__edit-content" }, [
                      _c(
                        "ul",
                        { staticClass: "modify-modal__room-list form" },
                        _vm._l(
                          _vm.confirmedReservations,
                          function (item, index) {
                            return _c(
                              "li",
                              {
                                key: item.id,
                                staticClass: "modify-modal__room-list-item",
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    class: {
                                      disabled: _vm.disableReservation(item),
                                    },
                                    attrs: { for: item.id },
                                  },
                                  [
                                    _vm.isMultiRoomReservation
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedRooms,
                                              expression: "selectedRooms",
                                            },
                                          ],
                                          attrs: {
                                            id: item.id,
                                            type: "checkbox",
                                            disabled:
                                              _vm.disableReservation(item),
                                          },
                                          domProps: {
                                            checked:
                                              !_vm.isMultiRoomReservation,
                                            value: item,
                                            checked: Array.isArray(
                                              _vm.selectedRooms
                                            )
                                              ? _vm._i(
                                                  _vm.selectedRooms,
                                                  item
                                                ) > -1
                                              : _vm.selectedRooms,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.selectedRooms,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = item,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectedRooms =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectedRooms = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.selectedRooms = $$c
                                              }
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.modifyBookingPropData
                                            .ModifyReservationRoomTitle
                                        ) +
                                        "\n              " +
                                        _vm._s(item.roomNumberOrder) +
                                        ": " +
                                        _vm._s(item.roomStays[0].roomName) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.disableReservation(item)
                                  ? _c(
                                      "v-dropdown",
                                      {
                                        staticClass:
                                          "tooltip tooltip-variant--modify-edit-modal",
                                        attrs: {
                                          "popper-class":
                                            "booking-modify-tooltip",
                                          placement: "top",
                                          distance: 22,
                                          skidding: 0,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "popper",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "tooltip-variant--modify-edit-modal tooltip-content",
                                                    },
                                                    [
                                                      _c("span", {
                                                        directives: [
                                                          {
                                                            name: "close-popper",
                                                            rawName:
                                                              "v-close-popper",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "icon-close",
                                                        attrs: {
                                                          "aria-label": "close",
                                                          tabindex: "0",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "tooltip-body",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.getTooltipMessage(
                                                                  item
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("button", {
                                          staticClass: "tooltip-icon icon-info",
                                          attrs: {
                                            role: "presentation",
                                            "aria-label":
                                              _vm.getTooltipMessage(item),
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _vm.selectedRooms.length > 0 &&
                      !!_vm.modifyBookingPropData.ModifyReservationDateWarning
                        ? _c("span", { staticClass: "disclaimer" }, [
                            _c("span", { staticClass: "icon-warning-red" }),
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.modifyBookingPropData
                                    .ModifyReservationDateWarning
                                ) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isStepTwo || !_vm.isMultiRoomReservation
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form modify-modal__edit-content -editList",
                      },
                      [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.editOptionSelected,
                                expression: "editOptionSelected",
                              },
                            ],
                            attrs: {
                              id: "modifyReservationInfo-0",
                              type: "radio",
                              name: "modifyReservationInfo",
                              value: "room-list",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.editOptionSelected,
                                "room-list"
                              ),
                            },
                            on: {
                              change: function ($event) {
                                _vm.editOptionSelected = "room-list"
                              },
                            },
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.ModifyReservationPopupStepTwoRoomServices
                              ) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.editOptionSelected === "room-list"
                          ? _c("span", { staticClass: "disclaimer" }, [
                              _c("span", { staticClass: "icon-warning-red" }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.ModifyReservationPopupStepTwoRoomServicesAlert
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasEnhancements
                          ? _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.editOptionSelected,
                                    expression: "editOptionSelected",
                                  },
                                ],
                                attrs: {
                                  id: "modifyReservationInfo-1",
                                  type: "radio",
                                  name: "modifyReservationInfo",
                                },
                                domProps: {
                                  value: _vm.isAuthenticated
                                    ? "enhancements"
                                    : "join-fans",
                                  checked: _vm._q(
                                    _vm.editOptionSelected,
                                    _vm.isAuthenticated
                                      ? "enhancements"
                                      : "join-fans"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.editOptionSelected = _vm.isAuthenticated
                                      ? "enhancements"
                                      : "join-fans"
                                  },
                                },
                              }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.ModifyReservationPopupStepTwoCompPrivilege
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.editOptionSelected,
                                expression: "editOptionSelected",
                              },
                            ],
                            attrs: {
                              id: "modifyReservationInfo-2",
                              type: "radio",
                              name: "modifyReservationInfo",
                              value: "check-out",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.editOptionSelected,
                                "check-out"
                              ),
                            },
                            on: {
                              change: function ($event) {
                                _vm.editOptionSelected = "check-out"
                              },
                            },
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.ModifyReservationPopupStepTwoGuestInfo
                              ) +
                              "\n        "
                          ),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "button-wrapper form-submit" }, [
                _vm.isMultiRoomReservation && !_vm.isStepTwo
                  ? _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "button--primary black size-md",
                          class: _vm.nextCtaDisabled ? "disabled" : "",
                          attrs: { disabled: _vm.nextCtaDisabled },
                          on: {
                            click: _vm.next,
                            keydown: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.next($event)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.next($event)
                              },
                            ],
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.ModifyReservationPopupStepOneCTANextLabel
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isStepTwo || !_vm.isMultiRoomReservation
                  ? _c("div", [
                      _vm.isMultiRoomReservation
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "button--secondary black size-md outlined",
                              on: {
                                click: _vm.goBack,
                                keydown: [
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.goBack($event)
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.goBack($event)
                                  },
                                ],
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.ModifyReservationPopupBackButtonLabel
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button--primary black size-md",
                          class: {
                            disabled: !_vm.editOptionSelected,
                            loading: _vm.isLoading,
                          },
                          attrs: {
                            disabled: !_vm.editOptionSelected || _vm.isLoading,
                          },
                          on: {
                            click: _vm.edit,
                            keydown: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.edit($event)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.edit($event)
                              },
                            ],
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.ModifyReservationPopupStepOneCTAEditLabel
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }